/** Brand colour theming with WCAG AA text colour (AGENTS.md 5.3). */
function lin(c: number): number {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}
export function luminance(hex: string): number {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return 0;
  const n = parseInt(m[1]!, 16);
  return 0.2126 * lin(n >> 16) + 0.7152 * lin((n >> 8) & 255) + 0.0722 * lin(n & 255);
}
export function contrast(a: string, b: string): number {
  const [l1, l2] = [luminance(a), luminance(b)].sort((x, y) => y - x) as [number, number];
  return (l1 + 0.05) / (l2 + 0.05);
}
export function onColour(bg: string): string {
  return contrast(bg, "#ffffff") >= contrast(bg, "#111111") ? "#ffffff" : "#111111";
}
/** Darkens a brand colour until it reaches 4.5:1 against white, for text and links. */
export function accessibleOnWhite(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return "#1f4e79";
  let n = parseInt(m[1]!, 16);
  let [r, g, b] = [n >> 16, (n >> 8) & 255, n & 255];
  let out = hex;
  for (let i = 0; i < 20 && contrast(out, "#ffffff") < 4.5; i++) {
    r = Math.round(r * 0.9);
    g = Math.round(g * 0.9);
    b = Math.round(b * 0.9);
    n = (r << 16) | (g << 8) | b;
    out = "#" + n.toString(16).padStart(6, "0");
  }
  return out;
}
export function applyTheme(root: HTMLElement, brand: string): void {
  root.style.setProperty("--brand", brand);
  root.style.setProperty("--on-brand", onColour(brand));
  root.style.setProperty("--brand-text", accessibleOnWhite(brand));
}
